// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__FI5Ln"};